export const dev = {
  pusher: {
    // used in pusher.service
    key: 'efcd0515750815eb92b7715368ab609b3a0e08c2c0251e37e6eaa9919c8302c3d9023869',
    beams: {
      instanceId: 'eeca0546260941ba8db775066ab26c9f3a5f419964734b7e972e5a39d1df720040657c160317676f154187444bfc27e949a49f5b'
    }
  }
}

export const prod = {
  pusher: {
    // used in pusher.service
    key: 'e4cf0645725d13bf97bb750165fe689c30085b944449bae18aa5b4f13bcd7da7112b9a07',
    beams: {
      instanceId: 'b0cd0912765d10ed8de623063eb26ccc6f0e41c063741d7e9527583487d8270545397810680bcfa038c8412e57751d12703fc19e',
      secretKey: '92ce7533745543bfe4c6760319ab68ee315c5c916b5340649128003fa5df7d7443437818f904e245d6aa7ce1de12fd1466d40362213b74bc4acca1921a0c6879ca364c3931cd6c6611ea6ff6a065a510'
    }
  },
  // used in threatmetrix.service
  orgId: 'e5cc01043b1c01e469be2eb511cb801b8eea3b3443eb231b',
  gtmId: '91ad7c5d0e2f4fd6e6b1772912b05073ea5cd296a046b2d72be4b7',
  stableAPIKey: 'b2cd0213225a4fbd8db4715365b26c9f3d0b419962741d7ec2265a3c828a215215317a461762de2ef9d004610a2739702916b409',

  // used in auth.effects.ts
  smartlook: 'e1ca0914770e47e8c5b3270b39fb6ecd6a585cc765741d6096265d3dd48a200140357b11df71c3417c72182410207daa7bf0538971fe5d39'
}

export const key = '656bc4c794074a1c0ee0389aaac04c4d0689918a3d4d249692c33d473acb6fe7';
export const iv = '5d41fbf61f607a8b71524872';
